// extracted by mini-css-extract-plugin
module.exports = {"modal":"InputResultModal_modal__2ib1y"};